export default __webpack_public_path__ + "static/media/logo-black-bg.db82cc98.png";